/*-----------------------------------------------------------------
- AlertMe
-----------------------------------------------------------------*/
export default {
    modal: {
        header: 'موجود شد به من اطلاع بده',
        title : 'روش اطلاع‌رسانی خود را انتخاب کنید:',

        channels: {
            mail   : 'ایمیل',
            sms    : 'پیامک',
            pattern: 'پیامک',
        },

        success: 'اطلاع‌رسانی با موفقیت ثبت شد.',
    },
};
